import { useState, useEffect } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import BarChartVertical from "../charts/tab2/BarChartVertical";
import TabularChart from "../charts/TabularChart";
import { Spinner } from "../spinner/Spinner";
import { Modal, Button } from 'react-bootstrap';
import { generate_New_Filter_ArrayObj } from "../../util";
import FocusLock from 'react-focus-lock';
import { IsArtDashboard } from "../../api/index";
import { safeHtml } from '../../utils/safeHtml';

// eslint-disable-next-line
let diagnosisOptions = [
    {
        index: 1,
        value: "F009",
        text: "No filter",
    },
    {
        index: 2,
        value: "F006",
        text: "F006 notFound",
    },
    {
        index: 3,
        value: "F005",
        text: "F005 notFound",
    },
    {
        index: 4,
        value: "F001",
        text: "F001 notFound",
    },
    {
        index: 5,
        value: "F003",
        text: "F003 notFound",
    },
    {
        index: 6,
        value: "F002",
        text: "F002 notFound",
    },
    {
        index: 7,
        value: "F004",
        text: "F004 notFound",
    },
    {
        index: 8,
        value: "F007",
        text: "F007 notFound",
    },
    {
        index: 9,
        value: "F008",
        text: "F008 notFound",
    },
];

function Tab3({ user, actions, isLoading, tables, tablesNational, clinicStatus, footnotes, currentTab }) {
    //setting data for drop down, pagination and question description
    const tabTitle = "Success Rates: Patients Using Donor Eggs tab";
    //useSetTitle("Success Rates: Patients Using Donor Eggs",true)

    const filterOption2_1 = generate_New_Filter_ArrayObj(tables.Questions, 0, 33);

    const [filterVal2, setFilterVal2] = useState(0);
    const [diagnosisVal, setDiagnosisVal] = useState(0)
    const [showTabularChart, setShowTabularChart] = useState(false);
    //national data toggle
    const [showNational, setShowNational] = useState(false);
    const isNationalData = sessionStorage.getItem('ClinicId') === '9999' ? true : false;
    const isArtDashBoard = IsArtDashboard();

    //setting show description text container
    const [truncateText1, setTruncateText1] = useState(true);
    const [truncateText2, setTruncateText2] = useState(true);
    //show filter modal
    const [visibleFilterMeta, setVisibleFilterMeta] = useState(false);
    const btnCloseFilterMeta = () => {
        setVisibleFilterMeta(false);
        document.body.removeAttribute('aria-hidden');
    };
    const btnShowFilterMeta = () => {
        setVisibleFilterMeta(true);
        document.body.setAttribute('aria-hidden', 'true');
    };
    //show donor modal
    const [visibleDonorMeta, setVisibleDonorMeta] = useState(false);
    const btnCloseDonorMeta = () => {
        setVisibleDonorMeta(false);
        document.body.removeAttribute('aria-hidden');
    };
    const btnShowDonorMeta = () => {
        setVisibleDonorMeta(true);
        document.body.setAttribute('aria-hidden', 'true');
    };

    useEffect(() => {
        return () => {
            // Remove aria-hidden from body on component unmount
            document.body.removeAttribute('aria-hidden');
        };
    }, []);

    if (isLoading) {
        return (
            <div>
                <>
                    <Spinner
                        message="Loading Data..."
                        backGround={true}
                        center={true}
                    />
                </>
            </div>
        )
    }

    const changeFilter = (index2) => {
        setFilterVal2(index2);
    };

    const changeDiagnosis = (obj) => {
        setDiagnosisVal(obj.index);
    };

    const handleKeyPressDiagnosis = (e, obj) => {
        if (e.code === "Enter" || e.which === 13) {
            setDiagnosisVal(obj.index);
        }
    }

    const getSelectBoxText = () => {
        var useFilterOption = filterOption2_1;
        return useFilterOption[filterVal2].Question;
    }

    const filterId = `${diagnosisOptions[diagnosisVal].value}`;
    // above may need to use useFilterOption

    const diagnosisFilters = tables.Filters
    if (typeof (diagnosisFilters) == 'undefined' || diagnosisFilters == null) return <p>Error: cannot find diagnosis Filters.</p>;
    // console.log(diagnosisFilters)
    for (let i = 0; i < diagnosisFilters.length; i++) {
        let diagFilter = diagnosisFilters[i]
        let diagOption = diagnosisOptions.find(diagOption => diagOption.value === diagFilter.FilterId)
        if (diagOption) diagOption.text = diagnosisFilters[i].FilterName
        else console.log('Warning: unexpected diagnosis Filters found ' + diagFilter.FilterId)
        // console.log(diagFilter)
    }
    // console.log(diagnosisOptions)

    const questions = tables.Questions
    if (typeof (questions) == 'undefined' || questions == null) return <p>Error: cannot find Questions.</p>;
    // console.log(questions)
    for (let i = 0; i < questions.length; i++) {
        let question = questions[i]
        let questOption1 = filterOption2_1.find(questOption => questOption.value === question.QuestionsIdId)
        if (questOption1) questOption1.text = questions[i].Question
        else {
            console.log('Warning: unexpected question found ' + question.QuestionsIdId)
        }
        // console.log(question)
    }
    // console.log(filterOption2_1)
    // console.log(filterOption2_2)

    var useFilterOption = filterOption2_1;

    //generate select a success factor option list
    let option2List = useFilterOption.map((filter, index) => {
        return (
            <option key={filter.value} value={index}>
                {safeHtml(filter.Question)}
            </option>
        )
    });

    const questionId = `${useFilterOption[filterVal2].value}`;
    // console.log("loaded for "+ questionId + " filterId: " + filterId)

    const questionData = tables.Data.find(question => question.QuestionId === questionId && question.FilterId === filterId)
    let questionDataNational;
    try {
        questionDataNational = tablesNational.Data.find(question => question.QuestionId === questionId && question.FilterId === filterId)
        if ((typeof (questionData) == 'undefined' || questionData == null) & footnotes.length <= 0) return <p>Error: cannot find data for question and diagnosis.</p>;
    } catch (e) {
        console.log('Allow Fail: ', e)
    }


    const questionKey = questionId + "_" + filterId
    let tableHeaderText,
        tableFooterFractional,
        tableFooterSupressed,
        hideTableUI,
        footNoteType;

    var tableFooterText;

    try {
        tableHeaderText = questionData.TableHeader;
        tableFooterFractional = questionData.FractionalDataMessage;
        tableFooterSupressed = questionData.SupressedDataMessage;
        tableFooterText = questionData.CycleCountMessage;
        hideTableUI = questionData.HideTableUI;
        footNoteType = questionData.FootNoteType;

        for (var i = tableFooterText.length - 1, c = 0; i >= 0; i--) {
            if (tableFooterText.charAt(i) >= '0' && tableFooterText.charAt(i) <= '9') {
                c++
            } else {
                c = 0
            }
            if (c === 4) {
                tableFooterText = tableFooterText.substring(0, i + 1) + ',' + tableFooterText.substring(i + 1)
                break;
            }
        }
    } catch (e) {
        //silent fail
    }

    var tableFooterTextNational;
    try {
        tableFooterTextNational = questionDataNational.CycleCountMessage

        for (let i = tableFooterTextNational.length - 1, c = 0; i >= 0; i--) {
            if (tableFooterTextNational.charAt(i) >= '0' && tableFooterTextNational.charAt(i) <= '9') {
                c++
            } else {
                c = 0
            }
            if (c === 4) {
                tableFooterTextNational = tableFooterTextNational.substring(0, i + 1) + ',' + tableFooterTextNational.substring(i + 1)
                break;
            }
        }

    } catch (e) {
        //silent fail
    }

    //show hide footnotes for cyclecount method
    const shouldShowTableUI = () => {
        // If cyclecount is null
        if (footNoteType === "null") {
            return !hideTableUI;
        }

        // When cyclecount is "0"
        if (footNoteType === "0") {
            // Show for non-ART dashboard
            if (!isArtDashBoard) {
                return true;
            }
            // Hide for ART dashboard
            return false;
        }

        // For all other cases, use original hideTableUI logic
        return !hideTableUI;
    };


    let Report;
    const title = 'Egg/Embryo Type'
    const showChart = (() => { try { return questionData.DataRows[5] === 'True' } catch (e) { return false } })();

    // console.log(showChart)

    switch (questionId) {
        case "Q030":
        case "Q031":
        case "Q032":
        case "Q033":
            //alert('vertical ' + questionId)
            if (!showTabularChart && showChart) {
                Report =
                    <BarChartVertical
                        data={questionData}
                        dataNational={questionDataNational}
                        showNational={showNational}
                        key={questionKey}
                        title={title}
                        chartTitle={tabTitle}
                        currentTab={currentTab}
                        selectedText={getSelectBoxText()}
                    />
            } else {
                Report =
                    <TabularChart
                        data={questionData}
                        dataNational={questionDataNational}
                        showNational={showNational}
                        key={questionKey}
                        showFractional={!showChart}
                        selectedText={getSelectBoxText()}
                    />
            }
            break;
        default:
            break;
    }

    return (
        <div className="tab_in pt-2 px-5">
            <Modal
                show={visibleFilterMeta}
                onHide={btnCloseFilterMeta}
                className="metaDataTableModal"
                aria-labelledby="metaDataTableModal"
                backdrop="static"
                keyboard={true}
                centered
            >
                <FocusLock returnFocus disabled={!visibleFilterMeta}>
                    <Modal.Header>
                        <Modal.Title id="metaDataTableModal">Diagnosis Description</Modal.Title>
                        <Button
                            onClick={btnCloseFilterMeta}
                            className="bg-transparent border-0 text-dark"
                            aria-label="Close diagnosis description modal"
                        >
                            <span aria-hidden="true">X</span>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <table>
                            <thead>
                                <tr>
                                    <th className="h5 py-3">Diagnosis</th>
                                    <th className="h5 py-3">Description</th>
                                </tr>
                            </thead>
                            <tbody className="table table-bordered bl-0" >
                                {tables.Filters && tables.Filters.map((row, index) => (
                                    <tr key={index} >
                                        <td className="small" dangerouslySetInnerHTML={{ __html: safeHtml(row.FilterName) }} />
                                        <td className="small" dangerouslySetInnerHTML={{ __html: safeHtml(row.FilterDescription) }} />
                                    </tr>
                                ))}
                            </tbody>
                        </table></Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={btnCloseFilterMeta}>
                            Close
                        </Button>
                    </Modal.Footer>
                </FocusLock>
            </Modal>

            <Modal
                show={visibleDonorMeta}
                onHide={btnCloseDonorMeta}
                className="metaDataTableModal"
                aria-labelledby="metaDataTableModalTwo"
                backdrop="static"
                keyboard={true}
                centered
            >
                <FocusLock returnFocus disabled={!visibleDonorMeta}>
                    <Modal.Header>
                        <Modal.Title id="metaDataTableModalTwo">Egg/Embryo Type Description</Modal.Title>
                        <Button
                            onClick={btnCloseDonorMeta}
                            className="bg-transparent border-0 text-dark"
                            aria-label="Close egg/embryo type description modal"
                        >
                            <span aria-hidden="true">X</span>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <table>
                            <thead>
                                <tr>
                                    <th className="h5 py-3">Type</th>
                                    <th className="h5 py-3">Description</th>
                                </tr>
                            </thead>
                            <tbody className="table table-bordered bl-0" >
                                {tables.Filters && tables.DonorClass.map((row, index) => (
                                    <tr key={index} >
                                        <td className="small" dangerouslySetInnerHTML={{ __html: safeHtml(row.DonorClassName) }} />
                                        <td className="small" dangerouslySetInnerHTML={{ __html: safeHtml(row.DonorClassDescription) }} />
                                    </tr>
                                ))}
                            </tbody>
                        </table></Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={btnCloseDonorMeta}>
                            Close
                        </Button>
                    </Modal.Footer>
                </FocusLock>
            </Modal>
            {clinicStatus === "None" && footnotes && footnotes.length > 0 && (
                <div className="alert-info mb-3 p-3 d-flex">
                    <span className="fill-p cdc-icon-info-circle-solid mr-2" aria-hidden="true"></span>
                    <div dangerouslySetInnerHTML={{ __html: safeHtml(footnotes[0].FootNote) }} />
                </div>
            )}
            {clinicStatus !== "None" && <>
                <div id="tab2Title1" className={truncateText1 ? "truncate-overflow" : ""} dangerouslySetInnerHTML={{ __html: safeHtml(tables.TopicDescription[0].TopicDescription) }} />
                <div className="d-print-none text-right mt-1">
                    <a
                        href="#/"
                        onClick={() => setTruncateText1(!truncateText1)}
                    >
                        {truncateText1 ? "Show full description" : "Hide full description"}
                        <i className={`align-middle ml-1 fa fa-2x ${truncateText1 ? "fa-angle-down" : "fa-angle-up"}`}></i>
                    </a>
                </div>
                <div className="bordered_grey_bot">
                    <div className="top">
                        <div className="columns row">
                            <div className="column col-12 is-three-quarters is-flex">
                                <div className="columns row">
                                    <div className="column col-12">
                                        <div className="is-flex is-justify-content-space-between column p-0 mb-1 d-print-none">
                                            <b id="lblTab4Question">Select a success factor</b>

                                        </div>
                                        <select
                                            id="tab2Question"
                                            className="control-input"
                                            value={filterVal2}
                                            key={filterVal2}
                                            onChange={(e) => {
                                                changeFilter(
                                                    e.target.value
                                                );
                                            }}
                                            aria-labelledby="lblTab4Question"
                                        >
                                            {option2List}
                                        </select>
                                    </div>
                                    <div className="column col-12 mt-2 text-right d-print-none">
                                        <span className="col font-italic">
                                            viewing {
                                                useFilterOption[filterVal2].index
                                            } of {useFilterOption.length}
                                        </span>
                                        <button
                                            className="btn btn-secondary is-info is-small mr-1 border-0"
                                            disabled={useFilterOption[filterVal2].index === 1}
                                            onClick={() => changeFilter(+filterVal2 - 1)}
                                            aria-label="Go to previous success factor"
                                        >
                                            Previous
                                        </button>
                                        <button
                                            className="btn btn-secondary is-info is-small border-0"
                                            disabled={useFilterOption[filterVal2].index === useFilterOption.length}
                                            onClick={() => changeFilter(+filterVal2 + 1)}
                                            aria-label="Go to next success factor"
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className={`mt-3 mb-2  ${truncateText2 ? "truncate-overflow" : ""} `} id="tab2Title2" dangerouslySetInnerHTML={{ __html: safeHtml(useFilterOption[filterVal2].header) }} />
                        {useFilterOption[filterVal2].header.length > 250 &&
                            <div className="d-print-none text-right mt-1">
                                <a
                                    href="#/"
                                    onClick={() => setTruncateText2(!truncateText2)}
                                >
                                    {truncateText2 ? "Show full description" : "Hide full description"}
                                    <i className={`align-middle ml-1 fa fa-2x ${truncateText2 ? "fa-angle-down" : "fa-angle-up"}`}></i>
                                </a>
                            </div>
                        }
                    </div>

                    {!isNationalData && isArtDashBoard &&
                        <div className="col-12 my-2 float-left offset-3 d-print-none">
                            <label className="mr-3 mb-0 ml-1">
                                <input
                                    type="checkbox"
                                    checked={showNational}
                                    onChange={() => setShowNational(!showNational)}
                                    className="mr-2"
                                />
                                Show National Data
                            </label>
                        </div>
                    }

                    <div className="bot">
                        <div className="columns row">
                            <div className="column col-3">
                                {/*<p className="is-hidden-mobile mb-3">&nbsp;</p>*/}
                                <div className="filter">
                                    <div className="title">
                                        Diagnosis
                                        <button
                                            className="button js-modal-trigger question_btn d-print-none"
                                            data-target="modal_help_1"
                                            aria-haspopup="dialog"
                                            aria-label="Diagnosis description"
                                            onClick={btnShowFilterMeta}
                                        >
                                            <span aria-hidden="true">?</span>
                                        </button>
                                    </div>
                                    {diagnosisOptions.map((diagnosis, index) => {
                                        const isSelected = diagnosisVal === index;
                                        return (
                                            <div
                                                key={index}
                                                className={`item ${isSelected ? 'active font-weight-bold' : ''}`}
                                                role="button"
                                                tabIndex="0"
                                                aria-pressed={isSelected}
                                                aria-label={`Select diagnosis: ${diagnosis.text}`}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        handleKeyPressDiagnosis(e, { index });
                                                    }
                                                }}
                                                onClick={() => {
                                                    changeDiagnosis({ index });
                                                }}
                                                dangerouslySetInnerHTML={{ __html: safeHtml(diagnosis.text) }}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="column col-9 filter_result_wrap">
                                <div id="pdfDiv">
                                    <div className="filter_result">
                                        <div className="title" style={{ justifyContent: "unset" }}>
                                            Patients using donor eggs/embryos
                                            <button
                                                className="button js-modal-trigger question_btn d-print-none"
                                                data-target="modal_help_1"
                                                aria-haspopup="dialog"
                                                aria-label="Patients using donor eggs/embryos description"
                                                onClick={btnShowDonorMeta}
                                            >
                                                <span aria-hidden="true">?</span>
                                            </button>
                                        </div>
                                        <div className="filter_result_bot">
                                            <p dangerouslySetInnerHTML={{ __html: safeHtml(getSelectBoxText()) }} />
                                            {shouldShowTableUI() && (
                                                <div style={{ float: "right" }} className="chartButtons d-print-none">
                                                    {showChart && <>
                                                        <button
                                                            style={{ padding: "0px 0px", borderWidth: "0px" }}
                                                            onClick={() => { setShowTabularChart(false); }}
                                                            aria-pressed={!showTabularChart}
                                                            aria-label="Switch to chart view"
                                                        >
                                                            <img
                                                                src={!showTabularChart ? "images/chart-toggle-selected.png" : "images/chart-toggle-unselected.png"}
                                                                alt=""
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                        <button
                                                            style={{ padding: "0px 0px", borderWidth: "0px" }}
                                                            onClick={() => { setShowTabularChart(true); }}
                                                            aria-pressed={showTabularChart}
                                                            aria-label="Switch to tabular view"
                                                        >
                                                            <img
                                                                src={showTabularChart ? "images/tabular-toggle-selected.png" : "images/tabular-toggle-unselected.png"}
                                                                alt=""
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                    </>
                                                    }
                                                </div>
                                            )}
                                            <div>
                                                <p>
                                                    <b>Filter:</b> <span dangerouslySetInnerHTML={{ __html: safeHtml(questionData.FilterId != "F009" ? tableHeaderText.replace('Filter: ', '') : "No Filter") }} />
                                                </p>
                                            </div>
                                            {((showTabularChart || !showChart) && shouldShowTableUI()) &&
                                                <div style={{ textAlign: "center" }}>
                                                    <p className="pb-0 mb-0">
                                                        <b>{title}<br /></b>
                                                    </p>
                                                </div>
                                            }
                                            {shouldShowTableUI() && (
                                                <div
                                                    className="result_table pt-1"
                                                    style={{
                                                        margin: "0 auto",
                                                        position: "relative",
                                                        overflow: "hidden",
                                                        maxWidth: "100%",
                                                        textAlign: "left",
                                                        lineHeight: "normal",
                                                        zindex: 0,
                                                        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                                                    }}
                                                >
                                                    {Report}

                                                    <div
                                                        className="highcharts-tooltip"
                                                        style={{
                                                            position: "absolute",
                                                            left: "242px",
                                                            top: "-9999px",
                                                            visibility: "visible",
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                position: "absolute",
                                                                whiteSpace: "nowrap",
                                                                fontFamily: "Arial, Helvetica, sans-serif",
                                                                fontSize: "12px",
                                                                color: "rgb(51, 51, 51)",
                                                                marginLeft: "0px",
                                                                marginTop: "0px",
                                                                left: "0px",
                                                                top: "0px",
                                                            }}
                                                            zindex="1"
                                                        >
                                                            <div className="rdquicktip-content">
                                                                <div className="body">
                                                                    <table className="rdquicktip-table">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td></td>
                                                                                <td id="tooltipText">
                                                                                    35-37 <br /> Age of patient <br /> 15.6
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            <div dangerouslySetInnerHTML={{ __html: safeHtml(!showNational && isNationalData ? ('National ' + tableFooterText).replace(/Clinic/g, '') : tableFooterText) }} />
                                            {!isNationalData && isArtDashBoard && showNational && <div dangerouslySetInnerHTML={{ __html: safeHtml(('National ' + tableFooterTextNational).replace(/Clinic/g, '')) }} />}
                                            <span dangerouslySetInnerHTML={{ __html: safeHtml(tableFooterFractional) }} /><br />
                                            <div dangerouslySetInnerHTML={{ __html: safeHtml(tableFooterSupressed) }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
}; // .mapStateToProps

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tab3)